module.exports = __webpack_public_path__ + "static/media/priorityMedium.e1d4376f.svg";